/* eslint-disable no-restricted-globals */
/* global wpApiSettings */
/* eslint-disable func-names, prefer-arrow-callback, object-shorthand, no-param-reassign, max-len */
import $ from 'jquery';
import 'parsleyjs';
import datepicker from 'js-datepicker';
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';

dayjs.extend( isBetween );

const $tickets = $( '.product_cat-consumer-tickets form' );
const $dateTimeChangeForm = $( '.js-accountDateTimeChange-ticket' );
const locationChangers = document.querySelectorAll( '.js-accountDateTimeChange-location' );
const selectTickets = document.querySelectorAll( '.wcpa_select_ticket, .wcpa_group_ticket' );
const datePickers = document.querySelectorAll( '.wcpa_date' );
const isDog = document.body.getAttribute( 'data-product-id' ) === '62193';
const hideGroupMessage = document.body.getAttribute( 'data-hide-group-message' ) === 'true';
const isGroup = document.body.getAttribute( 'data-is-group' );
const leadTime = document.body.getAttribute( 'data-lead-time' );
const addonsNumberPerDay = document.body.getAttribute( 'data-addons-number-per-day' );
const addonsLimitMessage = document.body.getAttribute( 'data-addons-limit-message' );
const addonsSoldOutMessage = document.body.getAttribute( 'data-addons-sold-out-message' );
const publicHolidays = document.body.getAttribute( 'data-public-holidays' );

function handleRandomMessage( datePickerEl, productId ) {
  const BLOSSOM_GENERAL_ADMISSION = '62198';
  if ( productId !== BLOSSOM_GENERAL_ADMISSION ) return;

  if ( dayjs( datePickerEl.value ).isBetween( '2023-09-29', '2023-10-1', 'day', '[]' ) ) {
    $( '.form-message' ).html( '<p class="ticketNotice noTickets">Please note there are limited blossoms left to see on these dates but lots of fun activities to enjoy!</p>' );
  }
}

// todo rename this function so it makes sense to handle public holidays and weekends
function handleWeekends( datePickerEl ) {
  const holidays = JSON.parse( publicHolidays );
  const isHoliday = holidays.some( holiday => holiday.date === datePickerEl.value );

	if ( dayjs( datePickerEl.value ).day() === 0 || dayjs( datePickerEl.value ).day() === 6 || isHoliday ) {
		$tickets.find( '.wcpa_weekends .wcpa_radio:last-child input' ).click();
	} else {
		$tickets.find( '.wcpa_weekends .wcpa_radio:first-child input' ).click();
	}
}

// toggle the price for items hidden with conditional login in the wcpa plugin. They are set to display block :(
function initHiddenPriceToggle() {
  $( '.wcpa_hidden_price_toggle input' ).on( 'click', function () {
    setTimeout( () => {
      const datePickerEl = document.querySelector( '.wcpa_date' );
      handleWeekends( datePickerEl );
    }, 100 );
  } );
}

function getTicketQty() {
	let tickets = 0;

	$( '.wcpa_select_ticket' ).each( function () {
		if ( $( this ).attr( 'name' ) === 'adult' || $( this ).attr( 'name' ) === 'child' || $( this ).attr( 'name' ) === 'number-of-people' || $( this ).attr( 'name' ) === '_group-booking' || $( this ).attr( 'name' ) === 'concession' ) {
			tickets += $( this ).val() === '' ? 0 : parseInt( $( this ).val(), 10 );
		} else if ( $( this ).attr( 'name' ) === 'family' ) {
			tickets += $( this ).val() === '' ? 0 : parseInt( $( this ).val() * 4, 10 );
		}
	} );

	$( '.wcpa_group_ticket' ).find( 'input' ).each( function () {
		if ( $( this ).prop( 'checked' ) ) {
			tickets += 1;
		}
	} );

	return tickets;
}

function hasInfant() {
	let result = false;
	$( '.wcpa_select_ticket' ).each( function () {
		if ( $( this ).attr( 'name' ) === 'infant' ) {
			if ( $( this ).val() >= 1 ) {
				result = true;
				return false;
			}
		}
	} );

	return result;
}

function scrollToMessage() {
	$( 'html, body' ).animate( { scrollTop: $( '.form-message' ).offset().top - ( $( window ).height() - $( '.form-message' ).outerHeight( true ) ) / 2 }, 200 );
}

function alertGroup() {
	const thedatepicker = document.querySelector( '.wcpa_date' );
  const linkedProductUrl = document.body.getAttribute( 'data-shared-product-url' );
  const groupMessage = linkedProductUrl ? JSON.parse( linkedProductUrl ) : '';

  if ( isGroup || !thedatepicker || hideGroupMessage ) {
		return;
	}

	$( '.groupTicket' ).remove();

	if ( dayjs( thedatepicker.value ).day() === 0 || dayjs( thedatepicker.value ).day() === 6 || !thedatepicker.value ) {
		return;
	}

	if ( $( '.wcpa_select_ticket[name="adult"]' ).val() > 19 ) {
		$( '.form-message' ).html( `<p class="ticketNotice ticketNotice--warning groupTicket">Groups with over 20 adults are eliglble for group discounts. <a href="${groupMessage}">Click here</a> to purchase</p>` );
	}
}

function validateForm() {
	$( '.wcpa_entry_time' ).find( 'input:first' ).attr( 'required', true );
	$( '.wcpa_type_select select[name="menu"]' ).attr( 'data-parsley-required', true );
	$( '.wcpa_legals input' ).attr( 'data-parsley-required', true );

	$tickets.parsley();

	$tickets.parsley().on( 'form:validate', function ( formInstance ) {
    if ( !isDog && !hasInfant() && getTicketQty() < 1 ) {
      $( '.form-message' ).html( '<p class="ticketNotice noTickets">Please add at least one ticket</p>' );
      scrollToMessage();
      formInstance.validationResult = false;
    }

		if ( !dayjs( $( '.wcpa_date' ).val() ).isValid() ) {
			$( '.form-message' ).html( '<p class="ticketNotice noTickets">Please choose a valid date</p>' );
			scrollToMessage();
			formInstance.validationResult = false;
		}

		if ( isGroup ) {
			if ( $( '.wcpa_select_ticket[name="adult"]' ).val() < 20 ) {
				$( '.form-message' ).html( '<p class="ticketNotice noTickets">Please add a minimum of 20 adult tickets</p>' );
				scrollToMessage();
				formInstance.validationResult = false;
			}
		}

		if ( $( '.wcpa_entry_time' ).find( 'input:checked' ).length === 0 ) {
			$( '.form-message' ).html( '<p class="ticketNotice noTickets">An entry time must be selected</p>' );
			scrollToMessage();
			formInstance.validationResult = false;
		}
	} );
}

function handlePhotoPack( productId, time, slot ) {
	const PHOTO_PACK_ID = '108242';
	const PREMIUM_TIME_SLOTS = ['9:00am', '10:00am', '11:00am', '1:00pm', '2:00pm', '3:00pm', '4:00pm'];

	if ( productId === PHOTO_PACK_ID ) {
		const packType = $( '.wcpa_group_ticket' ).find( 'input:checked' ).next( 'label' ).text()
			.indexOf( 'Hero Portrait ' ) !== -1 ? 'Hero Portrait' : 'Premium Portrait Package';

		// Hide premium slots
		if ( packType === 'Hero Portrait' && PREMIUM_TIME_SLOTS.includes( time ) ) {
			slot.setAttribute( 'style', 'display:none' );
		}

		// Hide non premium slots
		if ( packType === 'Premium Portrait Package' && !PREMIUM_TIME_SLOTS.includes( time ) ) {
			slot.setAttribute( 'style', 'display:none' );
		}
	}
}

function handleTimeslots( datePicker, productId ) {
	const form = datePicker.closest( 'form' );
	const timeSlots = form.querySelectorAll( '.wcpa_entry_time .wcpa_radio' );
	const productDetails = JSON.parse( form.getAttribute( 'data-product-details' ) );
	form.querySelector( '.form-message' ).innerHTML = '';

	const intialDate = datePicker.closest( 'form' ).getAttribute( 'data-initial-date' );
	const intialTime = datePicker.closest( 'form' ).getAttribute( 'data-initial-time' );

	const productTitle = productDetails ? productDetails[productId].title : document.body.getAttribute( 'data-product-title' );
  const productLocation = productDetails ? productDetails[productId].location : document.body.getAttribute( 'data-product-location' );
  const sharedTimeslotId = productDetails ? productDetails[productId].sharedTimeslotId : document.body.getAttribute( 'data-shared-timeslot-id' );

	if ( !datePicker.value ) {
		return;
	}

	// Check the selected time in ticket change form.
	if ( intialDate && intialTime ) {
		[...timeSlots].forEach( ( timeslot ) => {
			const timeslotLabel = timeslot.querySelector( 'label' );
			const timeslotInput = timeslot.querySelector( 'input' );
			timeslotInput.checked = false;

			if ( intialDate === datePicker.value && intialTime === timeslotLabel.innerText ) {
				timeslotInput.checked = true;
			}
		} );
	}

	const formdata = new FormData();
	formdata.append( 'date', datePicker.value );
	formdata.append( 'productId', productId );
	formdata.append( 'productTitle', productTitle );
	formdata.append( 'productLocation', productLocation );
	formdata.append( 'sharedTimeslotId', sharedTimeslotId );

	const requestOptions = {
		method: 'POST',
		body: formdata,
		redirect: 'follow',
	};

	if ( wpApiSettings.status ) {
		requestOptions.beforeSend = xhr => xhr.setRequestHeader( 'X-WP-Nonce', wpApiSettings.nonce );
	}

  // Add loading effect to timeslots
  [...timeSlots].forEach( timeslot => timeslot.setAttribute( 'style', 'display:block' ) );
  form.querySelector( '.wcpa_entry_time' ).classList.add( 'wcpa_timeslots-loading' );

	fetch( `${wpApiSettings.root}cherryhill/v1/dayValidate`, requestOptions )
		.then( response => response.text() )
		.then( ( result ) => {
			const dateSlotData = JSON.parse( result );
			let counter = 0;

      // Remove loading effect
      form.querySelector( '.wcpa_entry_time' ).classList.remove( 'wcpa_timeslots-loading' );

			timeSlots.forEach( ( slot ) => {
				const time = slot.innerText.trim();
				slot.querySelector( 'input' ).disabled = false;

				if ( dateSlotData[time] ) {
					const { sold, limit } = dateSlotData[time];
					let total = getTicketQty();

          // Get tickets from the account section
          if ( form.hasAttribute( 'data-ticket-qty' ) ) {
            total += parseInt( form.getAttribute( 'data-ticket-qty' ), 10 );
          }

          // Account for null value in result
          const soldVal = sold === null ? 0 : sold;

					console.log( `slot: ${time} sold: ${dateSlotData[time].sold} limit: ${dateSlotData[time].limit} total: ${getTicketQty()}` );
          const startTime = slot.innerText.trim().split( '-' )[0].replace( '.', ':' ).replace( ' ', '' );

					const parsedStartTime = dayjs( `${datePicker.value} ${startTime.slice( 0, -2 )} ${startTime.slice( -2 )}`, 'D MMMM YYYY h:mm a' );

					if ( parseInt( soldVal, 10 ) + parseInt( total, 10 ) >= parseInt( limit, 10 ) || dayjs() > parsedStartTime ) {
						// Hide blocked slots and disable sold out slots.
						if ( limit === '0' ) {
							slot.setAttribute( 'style', 'display:none' );
						} else {
							slot.setAttribute( 'style', 'display:block' );
							slot.querySelector( 'input' ).disabled = true;
              slot.querySelector( 'input' ).checked = false;
						}

						counter += 1;

						if ( counter === timeSlots.length ) {
							form.querySelector( '.form-message' ).innerHTML = '<p class="ticketNotice">There are not enough tickets available on this date/time for your booking</p>';
						}

            // also hide Photo Packs slots if sold out
            handlePhotoPack( productId, time, slot );
						return;
					}
				}

				slot.setAttribute( 'style', 'display:block' );

				// Sorry this is just for Photo Packs :(
				handlePhotoPack( productId, time, slot );
		} );
		} )
		.catch( error => console.log( 'error', error ) );
}

function handleAddons( datePicker ) {
	const selectedDate = new Date( datePicker.value );
  const currentDate = new Date();
  selectedDate.setHours( currentDate.getHours() );
  selectedDate.setMinutes( currentDate.getMinutes() );
  selectedDate.setSeconds( currentDate.getSeconds() );

	const addonLeadTime = new Date();
	addonLeadTime.setDate( addonLeadTime.getDate() + 1 );
	const limitedAddons = document.querySelectorAll( '.wcpa_form_item.limited_addon' );
	if ( !limitedAddons ) return;

	[...limitedAddons].forEach( ( limitedAddon ) => {
		const limitedAddonInput = limitedAddon.querySelector( 'input' );

		function toggleAddon( status, message ) {

			// Remove add on if already added
			if ( status && limitedAddonInput.checked ) {
				$( limitedAddonInput ).click();
			}

			limitedAddonInput.toggleAttribute( 'disabled', status );
			limitedAddon.classList.toggle( 'disabled', status );
			limitedAddonInput.checked = status ? false : null;

			$( limitedAddon ).find( '.parsley-errors-list' ).remove();

			if ( status ) {
				$( limitedAddon ).append( `<ul class="parsley-errors-list"><li>${message}</li></ul>` );
			}
		}

		toggleAddon( selectedDate < addonLeadTime, addonsLimitMessage );
		if ( selectedDate < addonLeadTime ) return;

		const formdata = new FormData();
		formdata.append( 'date', datePicker.value );

		const requestOptions = {
			method: 'POST',
			body: formdata,
			redirect: 'follow',
		};

		if ( wpApiSettings.status ) {
			requestOptions.beforeSend = xhr => xhr.setRequestHeader( 'X-WP-Nonce', wpApiSettings.nonce );
		}

		fetch( `${wpApiSettings.root}cherryhill/v1/addonValidate`, requestOptions )
			.then( response => response.text() )
			.then( ( result ) => {
        const addonSold = JSON.parse( result );

				if ( limitedAddon.classList.contains( 'limited_addon_the_picnic_box_parent' ) ) {
					toggleAddon( addonSold.The_Picnic_Box >= parseInt( addonsNumberPerDay, 10 ), addonsSoldOutMessage );
				}

        if ( limitedAddon.classList.contains( 'limited_addon_fruit_and_cheese_box_parent' ) ) {
					toggleAddon( addonSold.Fruit_and_Cheese_Box >= parseInt( addonsNumberPerDay, 10 ), addonsSoldOutMessage );
				}

        if ( limitedAddon.classList.contains( 'limited_addon_childrens_lunch_box_parent' ) ) {
					toggleAddon( addonSold.Childrens_Lunch_Box >= parseInt( addonsNumberPerDay, 10 ), addonsSoldOutMessage );
				}
			} ).catch( error => console.log( 'error', error ) );
	} );
}

function initDatepicker( datePickerEl, linkedProductId ) {
	datePickerEl.setAttribute( 'readonly', true );

	const productId = linkedProductId || document.body.getAttribute( 'data-product-id' ) || datePickerEl.closest( '.accountDateTimeChange-form' ).getAttribute( 'data-product-id' );
  const form = datePickerEl.closest( 'form' );
	const productDetails = JSON.parse( form.getAttribute( 'data-product-details' ) );

	const datesData = document.body.getAttribute( 'data-dates' )
		? JSON.parse( document.body.getAttribute( 'data-dates' ) )
		: productDetails[productId].dates;

  if ( !datesData ) return false;

	const today = new Date();
	const startDate = new Date( datesData.start_date );
	const endDate = new Date( datesData.end_date );
	let disabledDates = Array.from( datesData.remove_date, rdate => ( rdate.date !== '' ? new Date( rdate.date ) : null ) );
  const holidays = JSON.parse( publicHolidays );
  const holidayDates = holidays.map( ( { date } ) => new Date( date ) );
  let hasWeekends = '';

  if ( document.body.getAttribute( 'data-has-weekends' ) ) {
    hasWeekends = document.body.getAttribute( 'data-has-weekends' );
  }

  if ( datePickerEl.closest( '.accountDateTimeChange-form' ) ) {
    hasWeekends = datePickerEl.closest( '.accountDateTimeChange-form' ).getAttribute( 'data-has-weekends' );

    // If a weekeday ticket, disable weekends and holidays
    if ( dayjs( datePickerEl.value ).day() !== 0 && dayjs( datePickerEl.value ).day() !== 6 ) {
      hasWeekends = 'No';
      disabledDates = [...disabledDates, ...holidayDates];
    }
  }

  if ( leadTime ) {
		today.setDate( today.getDate() + parseInt( leadTime, 10 ) );
	}

	// Check if there is valid start and end date.
	if ( !dayjs( startDate ).isValid() || !dayjs( endDate ).isValid() ) return false;

	const datepickerObject = datepicker( datePickerEl, {
		position: 'br',
		startDate: startDate < today ? today : startDate,
		minDate: startDate < today ? today : startDate,
		maxDate: endDate,
		noWeekends: hasWeekends === 'No',
		disabledDates: disabledDates || null,
		onSelect: () => {
			handleTimeslots( datePickerEl, productId );
			handleAddons( datePickerEl );
			handleWeekends( datePickerEl );
      handleRandomMessage( datePickerEl, productId );
			alertGroup();
		},
		formatter: ( input, date ) => {
			const value = date.toLocaleDateString( 'en-au', { year: 'numeric', month: 'long', day: 'numeric' } );
			input.value = value;
		},
	} );

  return datepickerObject;
}

function initDateTimeChangeValidate() {
	$dateTimeChangeForm.each( function ( index ) {
		const $form = $( this );
		$form.parsley();

		const initialDate = $form.find( '.js-entry-date' ).val();
		const initialTime = $form.find( '.js-entry-time:checked' ).val();
		const initialProduct = $form.find( '.js-accountDateTimeChange-location' ).val();

		$form.parsley().on( 'form:validate', function ( formInstance ) {
			formInstance.validationResult = false;
			const isNewDate = initialDate !== $form.find( '.js-entry-date' ).val() || initialTime !== $form.find( '.js-entry-time:checked' ).val();
			const newProduct = initialProduct !== $form.find( '.js-accountDateTimeChange-location' ).val();     

      if ( $form.attr( 'data-has-linked-product-id' ) && !isNewDate && !newProduct ) {
        $form.find( '.form-message' ).html( '<p class="ticketNotice ticketNotice--warning notNewDate">Please select a new date, time or location</p>' );
      }

      if ( !$form.attr( 'data-has-linked-product-id' ) && !isNewDate ) {
        $form.find( '.form-message' ).html( '<p class="ticketNotice ticketNotice--warning notNewDate">Please select a new date or time</p>' );
      }


			if ( isNewDate || newProduct ) {
				const dateTimeChangeDate = new FormData();
				const productData = JSON.parse( $form.attr( 'data-product-details' ) );
				const title = productData[$form.find( '.js-accountDateTimeChange-location' ).val()] ? productData[$form.find( '.js-accountDateTimeChange-location' ).val()].title : null;

				dateTimeChangeDate.append( 'orderId', $form.attr( 'data-order-id' ) );
				dateTimeChangeDate.append( 'orderItemId', $form.attr( 'data-item-id' ) );
				dateTimeChangeDate.append( 'orderItemIndex', index );
				dateTimeChangeDate.append( 'date', $form.find( '.js-entry-date' ).val() );
				dateTimeChangeDate.append( 'time', $form.find( '.js-entry-time:checked' ).val() );
				dateTimeChangeDate.append( 'newProduct', newProduct );
				dateTimeChangeDate.append( 'title', title );
				dateTimeChangeDate.append( 'productId', $form.find( '.js-accountDateTimeChange-location' ).val() );

				const settings = {
					url: `${wpApiSettings.root}cherryhill/v1/change_product_date_time`,
					method: 'POST',
					timeout: 0,
					processData: false,
					mimeType: 'multipart/form-data',
					contentType: false,
					data: dateTimeChangeDate,
				};

				if ( wpApiSettings.status ) {
					settings.beforeSend = xhr => xhr.setRequestHeader( 'X-WP-Nonce', wpApiSettings.nonce );
				}

				$.ajax( settings )
					.done( ( response ) => {
						if ( $form.attr( 'data-has-linked-product-id' ) ) {
							$form.find( 'h6' ).text( JSON.parse( response ).productTitle );
						}
						$form.find( '.form-message' ).html( `<p class="ticketNotice">${JSON.parse( response ).message}</p>` );
					} ).fail( () => {
						console.log( 'api date time change failed' );
					} );
			}
		} );
	} );
}

function initEvents() {
	selectTickets.forEach( ( selectTicket ) => {
		selectTicket.addEventListener( 'change', ( e ) => {
			const datePicker = e.currentTarget.closest( 'form' ).querySelector( '.wcpa_date' );
			const productId = document.querySelector( 'body' ).getAttribute( 'data-product-id' );
			handleTimeslots( datePicker, productId );
			alertGroup();
		} );
	} );

	locationChangers.forEach( ( locationChange, index ) => {
		locationChange.addEventListener( 'change', () => {
      const datePicker = locationChange.closest( 'form' ).querySelector( '.wcpa_date' );
			const productId = locationChange.value;
      
      initDatepicker( datePicker, productId, true );
			handleTimeslots( datePicker, productId );
		} );
	} );
}

function initGroupPrices() {
  const isTourGroupAccount = document.body.getAttribute( 'data-is-tour-group-account' );
  if ( !isTourGroupAccount ) return;
  $tickets.find( '.wcpa_groups .wcpa_radio:last-child input' ).click();
}

function init() {
	if ( $tickets.length ) {
		$tickets.prepend( '<div class="form-message"></div>' );
		validateForm();
	}

	[...datePickers].forEach( ( datepickerEl, index ) => {
		initDatepicker( datepickerEl, false, index );
		const productId = datepickerEl.closest( 'form' ).getAttribute( 'data-product-id' );
		handleTimeslots( datepickerEl, productId );
	} );

	initEvents();
  initGroupPrices();
	initDateTimeChangeValidate();
  initHiddenPriceToggle();
}

export default {
	init,
};
